export const LocalStorageKeys = {
  Language: "lan",
  Access: "access",
  ViewMode: "ViewMode",
  SelectedBusiness: "selectedBusiness",
};
